var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SkuMaterials',{attrs:{"disabled":_vm.disabled,"isFormal":_vm.isFormal,"amzSkuCode":_vm.amzSkuCode,"amzSkuMaterialGroup":'packaging'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }